<script>
import * as monaco from "monaco-editor";
import { VueMonacoDiffEditor, loader } from '@guolao/vue-monaco-editor';

// loaded monaco-editor from `node_modules`
loader.config({ monaco });
// https://www.npmjs.com/package/@guolao/vue-monaco-editor?activeTab=readme
export default VueMonacoDiffEditor;
</script>

<style>
@import "monaco.css";
</style>
